import React from 'react';
import styled from 'styled-components';
import { RGBA_COLORS } from '../utils/colors';

interface TitleBlockProps {
  icon: string;
  title: string;
}

export const TitleBlock: React.FC<TitleBlockProps> = ({ icon, title }) => {
  return (
    <TitleBlockS className="titleBlock">
      <span>
        <i className={icon} />
      </span>
      <h2>{title}</h2>
    </TitleBlockS>
  );
};

const TitleBlockS = styled.div`
  display: inline-flex;
  width: 100%;
  height: 40px;
  color: white;
  align-items: center;
  background: ${RGBA_COLORS.getAccent()};
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    background: rgba(0, 0, 0, 0.1);
    height: 100%;
    font-size: 20px;
  }
  h2 {
    padding-left: 10px;
    font-weight: 500;
    font-size: 20px;
    margin: 0;
  }
`;
